import React, { useEffect, useState } from "react";
import {useSelector} from "react-redux";
import ConnectPaypalIdentity from "./connectPaypalIdentity";
import PaypalIdentityDetails from "./paypalIdentityDetails";
import LoadingSpinner from "../CommonComponents/loadingSpinner";

const PaypalIdentitySection = () => {
    const identity = useSelector(state => state.paypalIdentity);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(false);
    }, [identity]);

    return (
        <div className="p-2 ps-0 payoutsMethod">
            <span className="sub-title">Paypal Information</span>
            {identity === null && <ConnectPaypalIdentity/>}
            {identity !== null && <PaypalIdentityDetails setLoading={setLoading}/>}

            {loading && <LoadingSpinner target={"payouts-page-body"} />}
        </div>
    )
}

export default PaypalIdentitySection;